<template>
  <div>
    <el-dialog
      title="编辑维护用户"
      :visible.sync="visible"
      width="70%"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <el-form :inline="true" :model="dataForm" class="demo-form-inline">
        <el-form-item label="当前维护用户">
          <el-input
            v-model="dataForm.user"
            placeholder="当前维护用户"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">确认</el-button>
        </el-form-item>
      </el-form>
      <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <el-input
            v-model="searchForm.name"
            placeholder="用户名或姓名"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button type="default" @click="refreshForm">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="dataList"
        :row-class-name="tableRowClassName"
        @row-dblclick="selectRow($event)"
        v-loading="tabLoding"
        border
        @cell-mouse-enter="enter"
        @cell-mouse-leave="leave"
        style="width: 100%"
      >
        <el-table-column
          prop="loginName"
          header-align="center"
          align="center"
          label="用户名"
        >
        </el-table-column>
        <el-table-column
          prop="userName"
          header-align="center"
          align="center"
          label="姓名"
        >
          <template slot-scope="scope">
            <el-tooltip
              effect="dark"
              content="双击选择"
              :ref="'popover' + scope.row.id"
              placement="top"
            >
              <div>{{ scope.row.userName || '-' }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="deptName"
          header-align="center"
          align="center"
          label="所属组织"
        >
        </el-table-column>
        <el-table-column
          prop="remark"
          header-align="center"
          align="center"
          label="备注"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.remark || '-' }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="totalPage > 0">
        <el-pagination
          class="mt-sm"
          @size-change="sizeChangeHandle"
          @current-change="currentChangeHandle"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          :total="totalPage"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataForm: {
        user: ''
      },
      searchForm: {
        name: ''
      },
      tabLoding: false,
      dataList: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      visible: false,
      productInfo: '',
      selectUserId: ''
    }
  },
  methods: {
    init(info) {
      this.visible = true
      this.productInfo = info
      this.dataForm.user = info.maintainerUserName
      this.selectUserId = info.maintainerId
      this.searchForm.name = ''
      this.pageIndex = 1
      this.getDataList()
    },
    enter(row, column, cell) {
      this.$refs['popover' + row.id].showPopper = true
    },
    leave(row, column, cell) {
      this.$refs['popover' + row.id].showPopper = false
    },
    // 确认修改维护用户
    onSubmit() {
      this.$http({
        url: this.$http.adornUrl('/api/adminManage/updateMaintainer'),
        method: 'post',

        params: this.$http.adornParams({
          productId: this.productInfo.id,
          maintainer: this.dataForm.user,
          uid: this.selectUserId
        })
      })
        .then((res) => {
          if (res && res.resp_code === 0) {
            this.$message({
              message: res.resp_msg,
              type: 'success'
            })
            this.visible = false
            const maintainData = {
              id: this.selectUserId,
              name: this.dataForm.user
            }
            this.$emit('refreshMaintain', maintainData)
          } else {
            this.$message({
              message: res.resp_msg,
              type: 'error'
            })
          }
        })
        .catch(() => {})
    },
    search() {
      this.pageIndex = 1
      this.getDataList()
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.maintainerUserName === this.dataForm.user) {
        return 'current-row'
      }
      return ''
    },
    // 获取用户列表
    getDataList() {
      this.tabLoding = true
      this.$http({
        url: this.$http.adornUrl('/api/adminManage/allUsersInformation'),
        method: 'get',
        params: this.$http.adornParams({
          currentPage: this.pageIndex,
          size: this.pageSize,
          name: this.searchForm.name.trim(),
          hasAdmin: 0
        })
      })
        .then((res) => {
          const data = res.data
          if (data && res.resp_code === 0) {
            if (data.list.length === 0 && data.total > 0) {
              this.pageIndex = this.pageIndex - 1
              this.getDataList()
            } else {
              // data.list.splice(data.list.findIndex(item => item.loginName === "admin"), 1)
              this.dataList = data.list
              this.dataList.forEach((item) => {
                item.setup = false
                if (item.status === '0') {
                  item.setup = true
                }
              })
              this.dataList = JSON.parse(JSON.stringify(this.dataList))
              this.totalPage = data.total
            }
          } else {
            this.dataList = []
            this.totalPage = 0
          }
          this.tabLoding = false
        })
        .catch(() => {
          this.dataList = []
          this.totalPage = 0
          this.tabLoding = false
        })
    },
    // 重置
    refreshForm() {
      this.searchForm.name = ''
      this.pageIndex = 1
      this.getDataList()
    },
    // 每页数
    sizeChangeHandle(val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle(val) {
      this.pageIndex = val
      this.getDataList()
    },
    selectRow(event) {
      this.dataForm.user = event.userName
      this.selectUserId = event.id
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
